import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Initialize file logging (local dev only - logs to backend which writes to disk)
// TEMPORARILY DISABLED for debugging
// import './utils/fileLogger.js'

// Set dynamic page title based on domain name (matches Header component style)
const domainName = window.location.hostname.split('.')[0];
const displayName = domainName.toUpperCase();
document.title = displayName;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)